import React from 'react'

import i18n from 'i18n-literally'
import PropTypes from 'prop-types'

import Can from '~/src/Flags/Can'
import { urls as ipmUrls } from '~/src/IPM/bundle'
import { IPM_TAB, TASKS_TAB } from '~/src/Journal/Routes/AllEventsJournal/constants'
import Button from '~/src/UI/Shared/Button'

const displayName = 'JournalActions'

const JournalActions = props => {
  const {
    classes,
    openedTabValue,
  } = props

  const isTasksTabOpened = openedTabValue === TASKS_TAB
  const isIPMTabOpened = openedTabValue === IPM_TAB

  return (
    <>
      <div className={classes.action}>
        {isTasksTabOpened && (
          <Can actions="change_task">
            <Button
              fullWidth
              primaryAction
              variant="contained"
              color="primary"
              component="a"
              href="#/tasks/new"
            >
              {i18n`Add task`}
            </Button>
          </Can>
        )}
        {isIPMTabOpened && (
          <Can actions="change_pesticide_application">
            <Button
              fullWidth
              primaryAction
              variant="contained"
              color="primary"
              data-testid="journal-schedule-application-btn"
              href="#/tasks/newIPM"
            >
              {i18n`Schedule application`}
            </Button>
          </Can>
        )}
      </div>
      <div className={classes.actions}>
        {isIPMTabOpened && (
          <Can actions="change_pesticide_application">
            <Button
              color="primary"
              variant="text"
              component="a"
              data-testid="journal-add-application-btn"
              href={`#${ipmUrls.getUrl({ action: 'new' })}`}
            >
              {i18n`Record application`}
            </Button>
            <Button
              variant="outlined"
              color="primary"
              data-testid="journal-manage-pesticides-btn"
              href="/ipm/pesticides"
            >
              {i18n`Manage pesticides`}
            </Button>
          </Can>
        )}
      </div>
    </>
  )
}

JournalActions.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  openedTabValue: PropTypes.string.isRequired,
}

JournalActions.displayname = displayName

export default React.memo(JournalActions)
